module.exports = __webpack_public_path__ + "static/media/NorthWestTelegraph-devicecomp-min@2x.07f94002.png";